module.exports = __webpack_public_path__ + "static/media/sportAvatar__valorant.becfe36d.jpg";